import client from '@lib/http/client'

type RevertType = 0 | 1

export const markAsRead = ({
  identifiers,
  revert = 0
}: {
  identifiers: string[]
  revert?: RevertType
}) => client.post(`leads/mark-as-read?revert=${revert}`, { leads: identifiers })
